import { render, staticRenderFns } from "./editChapter.vue?vue&type=template&id=6218716d&scoped=true&"
import script from "./editChapter.vue?vue&type=script&lang=js&"
export * from "./editChapter.vue?vue&type=script&lang=js&"
import style0 from "./editChapter.vue?vue&type=style&index=0&id=6218716d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218716d",
  null
  
)

export default component.exports